module.exports = __webpack_public_path__ + "img/painpointHouse.a64a3d20.svg";